import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import { A } from "@/components/orto/assets";

const TITLE = "Pós em Ortopedia e Traumatologia | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação 100% online em Ortopedia e Traumatologia. 14 módulos, 360h, reconhecida pelo MEC. Decisões clínicas seguras, baseadas em evidências.";
const URL = "https://fisioemortopedia.com.br/orto2";

export const Route = createFileRoute("/orto2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: OrtoLP2,
});

function OrtoLP2() {
  return (
    <PosVNextLP
      product="orto"
      heroEyebrow="Pós-Graduação · 100% online · MEC"
      heroTitle="Fisioterapia em Ortopedia que decide com clareza"
      heroTitleHighlight="decide com clareza"
      heroSubtitle="A pós-graduação completa para você avaliar, raciocinar e tratar com confiança nas queixas musculoesqueléticas mais comuns e desafiadoras da prática clínica."
      promessas={[
        "Avaliar com clareza, mesmo nos casos mais complexos",
        "Definir um plano de tratamento baseado em evidências",
        "Identificar bandeiras vermelhas e quando encaminhar",
        "Prescrever exercício com dose, carga e progressão certas",
      ]}
      personas={[
        {
          titulo: "Fisio recém-formado",
          desc: "Que quer atender com segurança desde os primeiros pacientes, sem chutar conduta.",
        },
        {
          titulo: "Fisio com prática clínica",
          desc: "Que quer atualizar o raciocínio com base em evidências e ganhar autoridade no consultório.",
        },
        {
          titulo: "Fisio que quer se especializar",
          desc: "Que busca um título reconhecido pelo MEC e referência nacional em ortopedia.",
        },
      ]}
      coordenadorNome="Leandro Fukusawa"
      coordenadorFoto={A.coordenador}
      coordenadorQuote="A pós não te ensina o que pensar, ela te ensina como pensar diante de cada paciente."
      coordenadorBio="Coordenador da pós em Ortopedia e Traumatologia da FEO. Especialista em fisioterapia musculoesquelética com mais de 15 anos de prática clínica e ensino, com produção científica indexada e atuação na formação de fisioterapeutas em todo o Brasil."
      ementaSubtitle="Grade completa dos 14 módulos, lista de professores e cronograma da pós em Ortopedia."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
